



















































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import Gantt from '@/components/dhtmlx-gantt/dhtmlx-gantt.vue';
import { loginServe, performanceServer } from '@/api/installServer';
import publishObjectPath from '@/util/configRegistry';
import PreviewDialog from '@/views/responsibility/unit/previewDialog.vue';

@Component({
  components: { Gantt, PreviewDialog },
})
export default class ChoiceCheckDialog extends Vue {
  private visible = false;
  private people: any = '';
  private activeName: any = '';
  private parentName: any = '';
  private URLPath: any = '';
  private childList: any = [];
  private dataForm: any = {};
  validatorCodeUrl = ''; // 签名图片路径
  formData: any = {
    annex: '',
    annexList: [],
    assessContent: '',
    assessContentId: '',
    assessProjectId: '',
    assessProjectName: '',
    assessScore: 0,
    checkDepartmentId: '',
    checkDepartmentName: '',
    checkOpinion: '',
    checkPostId: '',
    checkPostName: '',
    checkSign: '',
    checkSignData: {
      createTime: '',
      id: '',
      name: '',
      signature: '',
      staffId: '',
      updateTime: '',
    },
    checkStaffIds: '',
    checkStaffNames: '',
    checkTime: '',
    childList: [],
    childTaskNum: 0,
    createStaffDepartmentName: '',
    createStaffName: '',
    createStaffPostName: '',
    createTime: '',
    currentOperateList: [],
    endTime: '',
    executeDepartmentId: '',
    executeDepartmentName: '',
    executePostId: '',
    executePostName: '',
    executeStaffIds: '',
    executeStaffNames: '',
    finishAnnex: '',
    finishAnnexList: [
      {
        id: '',
        md5: '',
        name: '',
        path: '',
        sort: 0,
      },
    ],
    finishCondition: '',
    finishDate: '',
    finishFlag: false,
    finishTime: '',
    finishWay: '',
    id: '',
    mainTaskId: '',
    name: '',
    operateLogList: [
      {
        annex: '',
        annexList: [
          {
            id: '',
            md5: '',
            name: '',
            path: '',
            sort: 0,
          },
        ],
        bizId: '',
        condition: '',
        departmentId: '',
        departmentName: '',
        id: '',
        postId: '',
        postName: '',
        staffId: '',
        staffName: '',
        status: '',
        time: '',
      },
    ],
    parentTaskId: '',
    realCheckStaffId: '',
    realCheckStaffName: '',
    realExecuteStaffId: '',
    realExecuteStaffName: '',
    receiveStaffId: '',
    receiveStaffName: '',
    receiveTime: '',
    remark: '',
    startTime: '',
    status: '',
    type: '',
  };

  private handleClick(tab: any, event: any, id?: any) {
    console.log(tab, event);
  }

  private async showDialog(data: any) {
    // 发起接口请求，获取分页数据
    performanceServer.getSinglePerformanceData(data.id).then((res: any) => {
      console.log();
      this.people = res.data.executeStaffNames ? res.data.executeStaffNames : res.data.realExecuteStaffName;

      const obj: any = {
        imgList: [],
        fileList: [],
      };
      res.data.finishAnnexList.forEach((i: any) => {
        const type = i.path.split('.')[1];
        if (type == 'PNG' || type == 'png' || type == 'JPG' || type == 'jpg' || type == 'JPEG' || type == 'jpeg' || type == 'BMP' || type == 'bmp' || type == 'GIF' || type == 'gif' || type == 'SVG' || type == 'svg') {
          i.type = 'image';
          obj.imgList.push(i);
        } else {
          i.type = type;
          obj.fileList.push(i);
        }
      });
      res.data.fileObj = obj;
      if (res.data.childList && res.data.childList.length > 0) {
        res.data.childList.forEach((i: any) => {
          const obj2: any = {
            imgList: [],
            fileList: [],
          };
          i.finishAnnexList.forEach((item: any) => {
            const type = item.path.split('.')[1];
            if (type == 'PNG' || type == 'png' || type == 'JPG' || type == 'jpg' || type == 'JPEG' || type == 'jpeg' || type == 'BMP' || type == 'bmp' || type == 'GIF' || type == 'gif' || type == 'SVG' || type == 'svg') {
              item.type = 'image';
              obj2.imgList.push(item);
            } else {
              item.type = type;
              obj2.fileList.push(item);
            }
          });
          i.fileObj = obj2;
        });
      }
      this.formData = res.data;
      console.log(this.formData);

      this.URLPath = publishObjectPath.imgPathWater;

      this.parentName = res.data.name;

      if (res.data.checkSign) {
        this.getValidatorCode(res.data.checkSign);
      }
      if (this.formData.childList.length > 0) {
        res.data.childList = res.data.childList.sort(this.dateDate('startTime', true));
        this.activeName = res.data.childList[0].id;
        this.dataForm = res.data;
        this.childList = res.data.childList;
        this.$nextTick(() => {
          // const credentialsEdit: any = 'credentialsEdit';
          // const credentialsComponent: any = this.$refs[credentialsEdit];
          // credentialsComponent.checkData(this.formData);
          (this.$refs['credentialsEdit'] as any).checkData(this.formData);
        });
      }
    });
    // .catch((error: any) => {
    //   this.$message.error('获取数据失败');
    // });
    this.visible = true;
  }

  // 子任务排序
  dateDate(property: any, type: any) {
    return function(a: any, b: any) {
      const value1 = a[property];
      const value2 = b[property];
      if (type) {
        return Date.parse(value1) - Date.parse(value2);
      } else {
        return Date.parse(value2) - Date.parse(value1);
      }
    };
  }

  /**
   * @desc 获取签名图片
   * @param1 暂无
   * @returns 暂无
   */
  getValidatorCode(id: any): void {
    performanceServer
      .getValidatorCode(id)
      .then((res: any) => {
        this.validatorCodeUrl = 'data:image/jpeg;base64,' + res.data.signature;
      })
      .catch((error: any) => {
        this.$message.error('获取签名图片失败，请重试！');
      });
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    if (this.formData.childList.length > 0) {
      this.$nextTick(() => {
        (this.$refs['credentialsEdit'] as any).destro();
      });
    }
    this.dataForm = {};
    this.validatorCodeUrl = '';
    this.visible = false;
  }

  chooseData(id: any) {
    this.activeName = id;
    this.handleClick('', '', id);
  }

  downloadHandleImg(url: any) {
    const urlPath: any = publishObjectPath.imgPathWater + url;
    window.open(urlPath, '_blank');
  }
  downloadHandle(url: any) {
    const urlPath: any = publishObjectPath.imgPathWater + url;
    (this as any).$axios
      .get(urlPath, {
        responseType: 'blob', //告诉服务器我们需要的响应格式
      })
      .then((res: any) => {
        const blob = new Blob([res.data], {
          type: res.data.type, //将会被放入到blob中的数组内容的MIME类型
        });
        const objectUrl = URL.createObjectURL(blob); //生成一个url
        window.location.href = objectUrl; //浏览器打开这个url
      })
      .catch(() => {});
  }
  openPreview(url: any) {
    const previewDialog: any = 'previewDialog';
    const previewDialogRef: any = this.$refs[previewDialog];
    previewDialogRef.showDialog(url);
  }
}
